import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`

  * {
    box-sizing: border-box;
    scrollbar-track-color: transparent;
  }

  body {
    background: #f7f9fa;
    font-size: 16px;
    margin: 0;
    font-family: "Pretendard", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  input, button {
    background-color: transparent;
    border: none;
    outline: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input:focus::placeholder {
    color: transparent;
  }

  input::placeholder {
    color: #bcbcbc;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  ol, ul, li {
    list-style: none;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  }

  patchPrintStyle {
    section {
      display: block !important;
    }

    article {
      height: 100% !important;
    }

    * {
      border: 0 none !important;
    }
  }
`;

export default GlobalStyles;
